import { render, staticRenderFns } from "./userCheck.vue?vue&type=template&id=54a64133&scoped=true&"
import script from "./userCheck.vue?vue&type=script&lang=js&"
export * from "./userCheck.vue?vue&type=script&lang=js&"
import style0 from "./userCheck.vue?vue&type=style&index=0&id=54a64133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a64133",
  null
  
)

export default component.exports